<template>
  <b-modal v-model="getShow" class="modal" centered :modal-class="isLoading ? 'loading' : ''">
    <template v-slot:modal-header="{ cancel }">
      <h5 class="modal-title">Sent invoice {{ invoice && invoice.project ? invoice.project.label : ''}}</h5>
      <button type="button" aria-label="Close" class="close" @click.prevent="confirmCancel(cancel)">
        <span class="material-icons">close</span>
      </button>
    </template>
    <div v-show="isSent" class="text-center text-uppercase text-danger">
      <h6>The invoice has been already sent</h6>
    </div>
    <FormGenerator :data="form" :showFormControls="false" :isLoading="isLoading" ref="sendEmailForm" @submit="submit">
      <template v-slot:Body="slotProps">
        <ckeditor :editor="editor" ref="ckeditorInstance" v-model="editorData" :config="editorConfig" />
      </template>
      <template v-slot:Items="slotProps">
        <h5 class="modal-title my-2">Attach files</h5>
        <div class="row mb-2 flex">
          <b-form-checkbox v-model="needSendBaseInvoice" name="check-button" class=" m-2 ">
            {{ invoice && invoice.file_name && invoice.file_name !== '' ? invoice.file_name : 'System invoice' }}
          </b-form-checkbox>
          <b-form-checkbox v-model="needSendBaseWorkLogsReport" name="check-button" class=" m-2">
            {{ invoice && invoice.worklogs_report_file_name && invoice.worklogs_report_file_name !== '' ?
            invoice.worklogs_report_file_name : 'System worklogs' }}
          </b-form-checkbox>
          <b-form-checkbox v-for="(file, index) in files" :key="index" v-model="file.selected" name="check-button"
            class="m-2">
            {{ file.name }}
          </b-form-checkbox>
        </div>
        <b-form-group class="invoice-uploader">
          <b-input-group>
            <b-form-file ref="fileInput" v-model="formFiles" @input="onFileUpload" multiple
              placeholder="Select a file or drag and drop here" drop-placeholder="Drop file here..."></b-form-file>
          </b-input-group>
          <b-input-group-prepend>
            <img src="images/upload-cloud.svg" />
          </b-input-group-prepend>
          <b-input-group-append>
            <b-button variant="outline" class="button bg-white" @click="triggerFileInput">Select File</b-button>
          </b-input-group-append>
        </b-form-group>
      </template>
    </FormGenerator>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="outline" class="button popup-footer-buttons" @click.prevent="confirmCancel(cancel)">Cancel</b-button>
      <b-button variant="primary" class="button popup-footer-buttons" @click.prevent="submitSendEmail(ok)">Send</b-button>
    </template>
  </b-modal>
</template>

<script>
import FormGenerator from '@components/FormGenerator'
import FinanceSendEmailMixin from '../../mixins/FinanceSendEmailMixin'

export default {
  components: {
    FormGenerator
  },
  props: {
    invoiceId: {
      type: Number
    },
    value: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  },
  mixins: [FinanceSendEmailMixin],
  computed: {
    getShow: {
      get () {
        if (this.value) {
          this.initInvoiceModalData(this.invoiceId)
        }
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    isLoading () {
      return this.loading || this.isEmailFormLoading
    }
  },
  methods: {
    submit (data) {
      this.sendEmail(data, 'invoice')
    },
    triggerFileInput () {
      this.$refs.fileInput.$refs.input.click()
    }
  }
}
</script>
